import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=bec8eda6&scoped=true&"
import script from "./reward.vue?vue&type=script&lang=js&"
export * from "./reward.vue?vue&type=script&lang=js&"
import style0 from "./reward.vue?vue&type=style&index=0&id=bec8eda6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec8eda6",
  null
  
)

export default component.exports